import type { PlanName } from '@/__generated__/openapi-types';

export const Plans: Record<string, PlanName> = {
  FREE: 'Free',
  TEAM: 'Team',
  ENTERPRISE: 'Enterprise',
} as const;

export type Plan = (typeof Plans)[keyof typeof Plans];
